import type { FC, ReactNode } from 'react'

import { useEffect, useState } from 'react'

const SENSORS = 412

/**
 * Live status: the model online, the sensors reporting (their count flickers by one or two every
 * few seconds, as sensors drop out and rejoin) and the age of the last scan. Screen readers get
 * the steady figures once rather than every flicker.
 */
export const StatusReadout: FC = (): ReactNode => {
    const [sensors, setSensors] = useState(SENSORS)

    useEffect(() => {
        let timer = 0

        const tick = (): void => {
            const roll = Math.random()

            setSensors(roll < 0.35 ? SENSORS : SENSORS + (roll < 0.6 ? -1 : roll < 0.75 ? -2 : roll < 0.92 ? 1 : 2))
            timer = window.setTimeout(tick, 2400 + Math.random() * 2600)
        }

        timer = window.setTimeout(tick, 2400)

        return () => window.clearTimeout(timer)
    }, [])

    return (
        <ul className='space-y-1.5'>
            <li className='hud flex items-center gap-2.5 text-ink'>
                <span className='signal-dot' aria-hidden='true' />
                Live model online
            </li>

            <li className='hud flex items-baseline gap-2 text-mute'>
                <span className='tabular-nums text-ink' aria-hidden='true'>
                    {sensors}
                </span>

                <span className='sr-only'>
                    {SENSORS}
                </span>

                Sensors reporting
            </li>

            <li className='hud flex items-baseline gap-2 text-mute'>
                Last scan

                <span className='text-ink'>
                    14 days ago
                </span>
            </li>
        </ul>
    )
}
